import { compareHash } from '../utils/ObjectUtil'

export const prefix = `$2a$10$DstN3bRFHGc0uIz51KpOme`

export const pastParticipants = {
  'twm-tabuelan-2024': {
    '1': '/yYSe48Vcttu1ZMQDNzrdPwEi/GBVp2',
  },
}

export const checkPastParticipant = (
  slug: string,
  bibNumber: string,
  firstName: string,
  lastName: string,
) => {
  if (!(slug in pastParticipants)) return false

  const pad = Object.keys(pastParticipants[slug])[0].length
  const bib = bibNumber.padStart(pad, '0')
  if (!(bib in pastParticipants[slug])) return false

  return compareHash(
    `${firstName.trim().toUpperCase()}|${lastName.trim().toUpperCase()}`,
    `${prefix}${pastParticipants[slug][bib]}`,
  )
}
